/**
 * Matches a word in a text for Chinese language.
 * Chinese doesn't use spaces between words, so we use exact string matching.
 * This function is compatible with the matchWordCustomHelper interface.
 *
 * @param {string|Object} sentence  The sentence to search in (can be string or sentence object).
 * @param {string} word             The word to search for.
 *
 * @returns {Array} An array of matches found in the text.
 */
export default function matchTextWithWord(sentence, word) {
  const matches = [];

  // Handle both string and sentence object
  const text = typeof sentence === 'string' ? sentence : sentence.text || sentence;

  if (!text || !word) {
    return matches;
  }

  // Convert both text and word to lowercase for case-insensitive matching
  const lowerText = text.toLowerCase();
  const lowerWord = word.toLowerCase();

  let startIndex = 0;
  let index;

  // Find all occurrences of the word in the text
  while ((index = lowerText.indexOf(lowerWord, startIndex)) !== -1) {
    // For Chinese, we add the matched word directly as a string
    // This matches the expected return format for the custom helper
    matches.push(word);
    startIndex = index + lowerWord.length;
  }

  return matches;
}
